module.exports = __webpack_public_path__ + "img/selected3-min.a5d9ba26.png";